import { Connection } from '../connections/connection'
import { FlowVersion } from '../flow-version'
import { flowStructureUtil } from '../util/flow-structure-util'
import { DetachStepsRequest } from './index'


export function _detachSteps(flowVersion: FlowVersion, request: DetachStepsRequest): void {
    const { sourceId, targetId } = request.connection
    if (!sourceId || !targetId) return

    const connections = flowStructureUtil.findSubflowForConnection(flowVersion, sourceId, targetId)?.connections
            || flowVersion.connections

    connections.splice(connections.findIndex(
        (conn: Connection) => conn.sourceId === sourceId && conn.targetId === targetId,
    ), 1)
}
